import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import "../../scss/card.css"
import { CModal } from '@coreui/react';
import ReactPlayer from 'react-player';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteVideoContentUpload = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()

    const initialFormState = {
        url: '',
        instituteMasterId: instituteMasterId,
        instituteSyllabusStructureMasterId: '',
        instituteLessonMasterId: '',
        instituteTopicMasterId: '',
        instituteSubjectMasterId: '',
        instituteSubTopicMasterId: ''
    }

    //error
    const initialErrorState = {

    }

    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [visible, setVisible] = useState(false)
    const [videoUrl, setVideoUrl] = useState("")

    const [isFullScreen, setFullScreen] = useState(false);
    const playerRef = useRef(null);
    const [played, setPlayed] = useState(0);
    const [play, setPlay] = useState(false)
    const [volume, setVolume] = useState(0.5);
    const [playbackRate, setPlaybackRate] = useState(1);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusStructureNameSort, setSyllabusStructureNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);
    const [subTopicNameSort, setSubTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const [error, setError] = useState(initialErrorState)
    const searchKeys = ["instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName", "instituteSubjectMasterDetails.subjectName", "instituteLessonMasterDetails.instituteLessonName", "instituteTopicMasterDetails.instituteTopicName", "instituteSubTopicMasterDetails.instituteSubTopicName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const handleSeekChange = (e) => {
        const seekValue = parseFloat(e.target.value);
        setPlayed(seekValue);
        playerRef.current.seekTo(seekValue, 'fraction');
    };

    const handleProgress = (progress) => {
        setPlayed(progress.played);
    };

    const handleVolumeChange = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    const handleSpeedChange = (e) => {
        setPlaybackRate(parseFloat(e.target.value));
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    const getApiUrl = () => {
        let apiUrl = `/get-institute-text-book-upload-video?instituteMasterId=${instituteMasterId}&`;

        if (subtopicData.instituteSyllabusStructureMasterId) {
            apiUrl += `instituteSyllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&`;
        }

        if (subtopicData.instituteSubjectMasterId) {
            apiUrl += `instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&`
        }

        if (subtopicData.instituteLessonMasterId) {
            apiUrl += `instituteLessonMasterId=${subtopicData.instituteLessonMasterId}&`;
        }

        if (subtopicData.instituteTopicMasterId) {
            apiUrl += `instituteTopicMasterId=${subtopicData.instituteTopicMasterId}&`;
        }

        if (subtopicData.instituteSubTopicMasterId) {
            apiUrl += `instituteSubTopicMasterId=${subtopicData.instituteSubTopicMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        if (subtopicData.instituteSyllabusStructureMasterId.length !== 0 && subtopicData.instituteSubjectMasterId !== '') {
            getVideoList();
        }
    }, [subtopicData.instituteSyllabusStructureMasterId, subtopicData.instituteSubjectMasterId, subtopicData.instituteLessonMasterId, subtopicData.instituteTopicMasterId, subtopicData.instituteSubTopicMasterId]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getVideoList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (subtopicData.instituteSyllabusStructureMasterId.length !== 0 && subtopicData.instituteSubjectMasterId !== '') {
                setSubtopicList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(subtopicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(subtopicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subtopicList.length) {
            endIndex = subtopicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(subtopicList.slice(startIndex, endIndex));
    }, [subtopicList, currPage, itemsPerPage]);

    const getVideoList = async () => {
        try {
            const response = await authorizedAxiosInstitute.get(getApiUrl());
            setSubtopicList(response.data.result);
        } catch (error) {
            setSubtopicList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-institute-syllabus-structure?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: '',
                instituteLessonMasterId: '',
                instituteTopicMasterId: '',
                instituteSubTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-institute-syllabus-structure-Wise-institute-subjects?id=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteLessonMasterId: '',
                instituteTopicMasterId: '',
                instituteSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&instituteSubjectMasterId=${e.target.value}`;

        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteTopicMasterId: '',
                instituteSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-lesson-wise-institute-sub-topic?id=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&instituteLessonMasterId=${subtopicData.instituteLessonMasterId}&instituteTopicMasterId=${e.target.value}&`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubTopicViewtopicList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setSubTopicViewtopicList([])
            });
    }

    const isValidUrl = (url) => {
        // Regular expression to match URL format
        const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
        // Test the given URL against the regex pattern
        return urlRegex.test(url);
    };

    const validateForm = () => {
        // Check if every error is an empty string
        const errorsValid = Object.values(error).every(error => error === '');

        // Check if every value in subtopicData is either a non-empty string or undefined
        const subtopicDataValid = Object.entries(subtopicData).every(([key, value]) => {
            // Exclude topicMasterId and subTopicMasterId from validation
            if (key !== 'instituteTopicMasterId' && key !== 'instituteSubTopicMasterId') {
                if (typeof value === 'string') {
                    if (value === '' && key !== 'url') { // Skip validation for URL if it's empty
                        return false;
                    } else if (key === 'url' && value !== '' && !isValidUrl(value)) { // Validate URL
                        return false;
                    }
                }
            }
            return true;
        });

        return errorsValid && subtopicDataValid;
    };

    useEffect(() => {
        if (!Object.values(error).every(error => error === '')) {
            for (const [key, value] of Object.entries(subtopicData)) {
                // Exclude topicMasterId and subTopicMasterId from validation
                if (key !== 'instituteTopicMasterId' && key !== 'instituteSubTopicMasterId') {
                    if (value === '' || value.length === 0 || (key === 'url' && !isValidUrl(value))) {
                        setError(prevData => ({
                            ...prevData,
                            [key]: value === '' ? 'This field is required.' : 'Invalid URL'
                        }));
                    } else {
                        setError(prevData => ({
                            ...prevData,
                            [key]: ''
                        }));
                    }
                }
            }
        }
    }, [subtopicData]);

    const addVideo = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-text-book-upload-video`;
                const response = await authorizedAxiosInstitute.post(apiUrl, subtopicData);
                await getVideoList();
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        instituteSubTopicMasterId: '',
                        url: ''
                    }
                })
                setSaveId(response.data.result.id);
                setSyllabusStructureNameSort(null);
                setSubjectSort(null);
                setLessonNameSort(null);
                setTopicNameSort(null);
                setSubTopicNameSort(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (key !== 'instituteTopicMasterId' && key !== 'instituteSubTopicMasterId') {
                    if (value === '' || value.length === 0) {
                        setError(prevData => ({
                            ...prevData,
                            [key]: 'This field is required.',
                        }));
                    } else {
                        setError(prevData => ({
                            ...prevData,
                            [key]: '',
                        }));
                    }
                }
            }

            // Check if URL is invalid
            if (subtopicData.url !== "" || subtopicData.url.length !== 0) {
                if (!isValidUrl(subtopicData.url)) {
                    setError(prevData => ({
                        ...prevData,
                        url: 'Invalid URL',
                    }));
                }
            }
        }
    }

    const deleteVideo = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-text-book-upload-video?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, subtopicList.length);
                await getVideoList();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateVideo = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-text-book-upload-video?id=${editId}`;
            const response = await authorizedAxiosInstitute.put(apiUrl, subtopicData);
            await getVideoList();
            setEditId(null);
            setSaveId(response.data.result.id);
            setSubtopicData((prevData) => {
                return {
                    ...prevData,
                    url: ''
                }
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    const reset = () => {
        setSubtopicData(initialFormState);
        setError(initialErrorState);
        setSubtopicList([]);
        setEditId('');
    }

    useEffect(() => {
        if (syllabusStructureNameSort == true || syllabusStructureNameSort == false) {
            setSubjectSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [syllabusStructureNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setSubTopicNameSort(null);
        }
    }, [topicNameSort])

    useEffect(() => {
        if (subTopicNameSort == true || subTopicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
        }
    }, [subTopicNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>

                            <li className="breadcrumb-item active"><span>Institute Upload Video</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-upload"></i>Institute Upload Video</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSyllabusStructureMasterId' onChange={handleSyllabusChange} value={subtopicData.instituteSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.instituteSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.instituteSyllabusStructureMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={subtopicData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteLessonMasterId' onChange={handleLessonChange} value={subtopicData.instituteLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.instituteLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteLessonMasterId && <p style={{ color: 'red' }}>{error.instituteLessonMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteTopicMasterId' onChange={handleTopicChange} value={subtopicData.instituteTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.instituteTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteTopicMasterId && <p style={{ color: 'red' }}>{error.instituteTopicMasterId}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSubTopicMasterId' onChange={handleInputChange} value={subtopicData.instituteSubTopicMasterId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicViewtopicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.instituteSubTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Video Url:</label>
                                                    <input required type="text" className="form-control" name="url" value={subtopicData.url} onChange={handleInputChange} />
                                                    {error.url && <p style={{ color: 'red' }}>{error.url}</p>}
                                                </div>
                                            </div>

                                            <CModal
                                                backdrop="static"
                                                visible={visible}
                                                onClose={() => setVisible(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                                className={isFullScreen ? "full_scr_view" : ""}
                                            >
                                                <button className="close-button video-close" onClick={() => setVisible(false)}><i class="fa fa-window-close fa-2xl" aria-hidden="true"></i></button>
                                                <div className="test test-player">
                                                    <ReactPlayer
                                                        ref={playerRef}
                                                        url={videoUrl}
                                                        playing={play}
                                                        volume={volume}
                                                        onProgress={handleProgress}
                                                        playbackRate={playbackRate}
                                                    >
                                                    </ReactPlayer>
                                                    <div className="overlay-layer">
                                                        <div className="trigger" onClick={() => setPlay(!play)} >Play</div>
                                                    </div>
                                                </div>
                                                <div className="video_content_bottom">
                                                    <div className="video_progress">
                                                        <input
                                                            type="range"
                                                            min={0}
                                                            max={1}
                                                            step="any"
                                                            value={played}
                                                            onChange={handleSeekChange}
                                                            className="input_slider"
                                                        />
                                                    </div>

                                                    <div className='play_pause_sound'>
                                                        <div className='sound'>
                                                            {!play ? <button onClick={() => setPlay(true)} className="play_pause_btn"> <i class="fa fa-play"></i></button> :
                                                                <button onClick={() => setPlay(false)} className="play_pause_btn"><i class="fa fa-pause"></i></button>}

                                                            {volume >= 0.5 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-high"></i>
                                                            </button>}
                                                            {volume < 0.5 && volume > 0 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-low"></i>
                                                            </button>}
                                                            {volume == 0 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-xmark"></i>
                                                            </button>}

                                                            <div className='sound_bar'>
                                                                <input
                                                                    type="range"
                                                                    value={volume}
                                                                    onChange={handleVolumeChange}
                                                                    min="0"
                                                                    max="1"
                                                                    step="0.01"
                                                                    className="input_slider"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='playbeack_speed'>
                                                            <span>Playback speed</span>
                                                            <select onClick={handleSpeedChange}>
                                                                <option value={0.25}>0.25</option>
                                                                <option value={0.5}>0.5</option>
                                                                <option value={0.75}>0.75</option>
                                                                <option selected value={1}>Normal</option>
                                                                <option value={1.25}>1.25</option>
                                                                <option value={1.5}>1.5</option>
                                                                <option value={1.75}>1.75</option>
                                                            </select>
                                                        </div>
                                                        {/* <div className='fullscreen_mode'>
                                                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}> {isFullScreen ? <i class="fa fa-expand"></i> : <i class="fa fa-compress"></i>}</button>
                                                        </div> */}

                                                        <div className='fullscreen_mode'>
                                                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}>{isFullScreen ? <i className="fa fa-compress"></i> : <i className="fa fa-expand"></i>}</button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </CModal>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addVideo}>Save</button>
                                                        }                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={reset}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateVideo} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Structure Name
                                                                            <SortIcon sortState={syllabusStructureNameSort} setSortState={setSyllabusStructureNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteLessonMasterDetails.instituteLessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteTopicMasterDetails.instituteTopicName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Sub Topic Name
                                                                            <SortIcon sortState={subTopicNameSort} setSortState={setSubTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteSubTopicMasterDetails.instituteSubTopicName"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Video
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((subtopic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{subtopic?.instituteSyllabusStructureMasterDetails?.instituteSyllabusStructureName}</td>
                                                                                        <td>{subtopic?.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                        <td>{subtopic?.instituteLessonMasterDetails?.instituteLessonName}</td>
                                                                                        <td>{subtopic?.instituteTopicMasterDetails?.instituteTopicName}</td>
                                                                                        <td>{subtopic?.instituteSubTopicMasterDetails?.instituteSubTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setVideoUrl(subtopic?.url)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className=" btn-outline-warning edit_icon" title='Coming Soon...' disabled type="button" onClick={() => {
                                                                                                setSubtopicData({
                                                                                                    url: subtopic?.url,
                                                                                                    instituteMasterId: instituteMasterId,
                                                                                                    instituteSubTopicMasterId: subtopic?.instituteSubTopicMasterId,
                                                                                                    instituteLessonMasterId: subtopic?.instituteLessonMasterId,
                                                                                                    instituteTopicMasterId: subtopic?.instituteTopicMasterId,
                                                                                                    instituteSyllabusStructureMasterId: subtopic?.instituteSubTopicMasterId,
                                                                                                    instituteSubjectMasterId: subtopic?.instituteSubjectMasterId

                                                                                                });
                                                                                                setEditId(subtopic.id);
                                                                                                setTopicList([{
                                                                                                    id: subtopic?.instituteTopicMasterId,
                                                                                                    instituteTopicName: subtopic.instituteTopicMasterDetails?.instituteTopicName
                                                                                                }]);

                                                                                                setSubTopicViewtopicList([{
                                                                                                    id: subtopic?.instituteSubTopicMasterId,
                                                                                                    instituteSubTopicName: subtopic?.instituteSubTopicMasterDetails?.instituteSubTopicName
                                                                                                }]);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className=" btn-outline-danger delete_icon" title='Coming Soon...' disabled type="button" /*disabled={editId === subtopic.id}*/ onClick={() => deleteVideo(subtopic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Sub Topic Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subtopicList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteVideoContentUpload;